
import React from 'react';

interface LandingViewProps {
  onNavigate: (route: 'landing' | 'login' | 'admin' | 'menu', slug?: string) => void;
}

export const LandingView: React.FC<LandingViewProps> = ({ onNavigate }) => {
  const heroImageUrl = "https://coreoffers.store/img/banner-delyon.png";

  const exampleRestaurants = [
    {
      name: "Bella Pizza Artesanal",
      slug: "bella-pizza",
      image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&q=80&w=600",
      description: "Pizzas feitas no forno a lenha com ingredientes premium."
    },
    {
      name: "Açaí Tropical do Porto",
      slug: "acai-porto",
      image: "https://images.unsplash.com/photo-1590301157890-4810ed352733?auto=format&fit=crop&q=80&w=600",
      description: "O melhor açaí da região com acompanhamentos ilimitados."
    },
    {
      name: "Monster Burger & Co",
      slug: "monster-burger",
      image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&q=80&w=600",
      description: "Hambúrgueres artesanais monstros para fomes gigantes."
    }
  ];

  const handleHireClick = (planName: string) => {
    const phone = "5561991779152";
    let message = "";

    if (planName === 'Essencial') {
      message = "Olá!\nTenho interesse no *Plano Essencial do Delyon*.\n\nGostaria de saber como funciona a contratação e quais são os próximos passos para colocar meu restaurante no sistema.";
    } else if (planName === 'Profissional') {
      message = "Olá!\nTenho interesse no *Plano Profissional do Delyon*.\n\nQuero organizar meus pedidos, ter relatórios de vendas e começar a vender melhor pelo WhatsApp.\nPode me explicar como funciona a contratação?";
    } else if (planName === 'Gestão Avançada') {
      message = "Olá!\nTenho interesse no *Plano Gestão Avançada do Delyon*.\n\nQuero uma solução completa para gerenciar meu delivery e acompanhar os resultados do meu negócio.\nGostaria de conversar sobre a contratação.";
    }

    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* Navbar */}
      <nav className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between sticky top-0 bg-white/80 backdrop-blur-md z-50 border-b border-slate-100">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 bg-orange-600 rounded-xl flex items-center justify-center text-white font-extrabold shadow-lg shadow-orange-200">D</div>
          <span className="text-xl font-extrabold tracking-tight text-slate-900">Delyon</span>
        </div>
        <div className="hidden md:flex gap-10 text-sm font-semibold text-slate-500">
          <button onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})} className="hover:text-orange-600 transition-colors">Início</button>
          <button onClick={() => document.getElementById('examples')?.scrollIntoView({behavior: 'smooth'})} className="hover:text-orange-600 transition-colors">Exemplos</button>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({behavior: 'smooth'})} className="hover:text-orange-600 transition-colors">Preço</button>
        </div>
        <div className="flex items-center gap-4">
          <button 
            onClick={() => onNavigate('login')}
            className="text-sm font-bold text-white bg-slate-900 px-6 py-3 rounded-xl hover:bg-orange-600 transition-all shadow-lg"
          >
            Acessar Painel
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative overflow-hidden pt-16 pb-12 md:pt-28 md:pb-24 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-10 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-orange-50 text-orange-700 px-4 py-1.5 rounded-full text-xs font-bold border border-orange-100 uppercase tracking-widest">
              O futuro do delivery chegou
            </div>
            
            <h1 className="text-5xl md:text-7xl font-extrabold text-slate-900 leading-[1.05] tracking-tight">
              Pedidos automáticos <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-amber-600">Atendimento inteligente</span>
            </h1>
            
            <p className="text-xl text-slate-500 max-w-xl mx-auto lg:mx-0 leading-relaxed font-medium">
              Delyon automatiza seus pedidos via WhatsApp e organiza sua gestão em uma única plataforma elegante e apetitosa.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start pt-4">
              <button 
                onClick={() => document.getElementById('pricing')?.scrollIntoView({behavior: 'smooth'})}
                className="bg-slate-900 text-white px-8 py-5 rounded-2xl font-bold text-lg hover:bg-orange-600 transition-all shadow-2xl"
              >
                Ver Planos e Preços
              </button>
              <button 
                onClick={() => document.getElementById('examples')?.scrollIntoView({behavior: 'smooth'})}
                className="flex items-center gap-3 bg-white border border-slate-200 text-slate-700 px-8 py-5 rounded-2xl font-bold text-lg hover:bg-slate-50 transition-all shadow-sm"
              >
                Explorar Exemplos
              </button>
            </div>
          </div>
          
          <div className="relative group">
            <div className="bg-white p-2 rounded-[2.5rem] shadow-2xl shadow-orange-100 overflow-hidden border border-slate-50">
              <img 
                src={heroImageUrl} 
                alt="Delyon Mockup" 
                className="rounded-[2rem] object-cover w-full h-auto min-h-[400px]"
                referrerPolicy="no-referrer"
                loading="lazy"
                onError={(e) => {
                   (e.target as HTMLImageElement).src = "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=800";
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Examples Carousel Section */}
      <section id="examples" className="py-24 px-6 overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 text-center lg:text-left">
            <h2 className="text-4xl font-extrabold text-slate-900 tracking-tight">Experimente o Cardápio</h2>
            <p className="text-lg text-slate-500 font-medium mt-2">Clique em um dos nossos modelos para ver como seu cliente fará o pedido.</p>
          </div>

          <div className="flex gap-6 overflow-x-auto pb-8 snap-x no-scrollbar">
            {exampleRestaurants.map((res, idx) => (
              <div 
                key={idx} 
                onClick={() => onNavigate('menu', res.slug)}
                className="min-w-[300px] md:min-w-[400px] snap-center cursor-pointer group relative bg-white rounded-[2.5rem] overflow-hidden border border-slate-100 shadow-lg hover:shadow-2xl transition-all duration-500"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={res.image} 
                    alt={res.name} 
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" 
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent opacity-60"></div>
                </div>
                
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <div className="inline-flex bg-orange-600 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest mb-3">Modelo {idx + 1}</div>
                  <h3 className="text-2xl font-black mb-2">{res.name}</h3>
                  <p className="text-sm text-slate-200 font-medium opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 line-clamp-2">
                    {res.description}
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-sm font-bold text-orange-400 opacity-0 group-hover:opacity-100 transition-opacity">
                    Ver Cardápio <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <style>{`
          .no-scrollbar::-webkit-scrollbar { display: none; }
          .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        `}</style>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-24 px-6 bg-slate-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4">Investimento justo para o seu negócio</h2>
            <p className="text-lg text-slate-500 font-medium">Escolha o plano que melhor se adapta ao seu momento.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto items-stretch">
            {/* PLANO ESSENCIAL */}
            <div className="bg-white border border-slate-200 rounded-[3rem] p-8 shadow-xl flex flex-col transition-transform hover:scale-[1.02]">
              <div className="mb-8 text-center">
                <h3 className="text-lg font-black text-slate-900 uppercase tracking-widest">Essencial</h3>
                <p className="text-slate-500 font-bold text-xs mt-2 leading-relaxed min-h-[32px]">Ideal para começar a vender pelo WhatsApp</p>
                <div className="flex items-baseline justify-center gap-1 my-8">
                  <span className="text-xl font-bold text-slate-900">R$</span>
                  <span className="text-5xl font-black text-slate-900 tracking-tighter">49,90</span>
                  <span className="text-slate-400 font-bold text-sm">/mês</span>
                </div>
              </div>

              <ul className="space-y-3.5 mb-10 flex-1">
                {[
                  "Cardápio digital online",
                  "Página exclusiva do restaurante",
                  "Pedidos via WhatsApp",
                  "Checkout simples",
                  "Até 20 itens no cardápio",
                  "Categorias ilimitadas",
                  "Taxa de entrega configurável",
                  "Horários de funcionamento",
                  "Link personalizado",
                  "Suporte via WhatsApp"
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-slate-700 font-semibold text-xs">
                    <div className="w-4 h-4 bg-slate-100 text-slate-500 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M5 13l4 4L19 7"></path></svg>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>

              <div className="pt-6 border-t border-slate-50">
                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest text-center mb-5">Você configura tudo pelo painel.</p>
                <button 
                  onClick={() => handleHireClick('Essencial')}
                  className="block w-full bg-slate-100 text-slate-900 text-center font-black py-4 rounded-2xl hover:bg-slate-200 transition-all text-sm"
                >
                  Contratar Agora
                </button>
              </div>
            </div>

            {/* PLANO PROFISSIONAL */}
            <div className="bg-white border-2 border-blue-600 rounded-[3rem] p-8 shadow-2xl relative flex flex-col transform md:scale-105 z-10 transition-transform hover:scale-[1.07]">
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-blue-600 text-white px-5 py-2 rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg">
                Recomendado
              </div>
              
              <div className="mb-8 text-center">
                <h3 className="text-lg font-black text-blue-600 uppercase tracking-widest">Profissional</h3>
                <p className="text-slate-500 font-bold text-xs mt-2 leading-relaxed min-h-[32px]">Para quem quer vender mais e entender o negócio</p>
                <div className="flex items-baseline justify-center gap-1 my-8">
                  <span className="text-xl font-bold text-slate-900">R$</span>
                  <span className="text-5xl font-black text-slate-900 tracking-tighter">79,90</span>
                  <span className="text-slate-400 font-bold text-sm">/mês</span>
                </div>
              </div>

              <ul className="space-y-3.5 mb-10 flex-1">
                <li className="flex items-center gap-3 text-blue-600 font-black text-[10px] uppercase tracking-widest mb-4">
                  Tudo do Essencial, mais:
                </li>
                {[
                  "Itens ilimitados no cardápio",
                  "Configuração inicial inclusa",
                  "Até 10 alterações mensais",
                  "Estatísticas de acesso",
                  "Estatísticas de pedidos",
                  "Relatórios de vendas",
                  "Suporte prioritário"
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-slate-700 font-semibold text-xs">
                    <div className="w-4 h-4 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M5 13l4 4L19 7"></path></svg>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>

              <div className="pt-6 border-t border-slate-50">
                <p className="text-[10px] font-black text-blue-600 uppercase tracking-widest text-center mb-5">Nós cuidamos da parte técnica pra você.</p>
                <button 
                  onClick={() => handleHireClick('Profissional')}
                  className="block w-full bg-blue-600 text-white text-center font-black py-4 rounded-2xl hover:bg-blue-700 transition-all text-sm shadow-xl shadow-blue-100"
                >
                  Contratar Agora
                </button>
              </div>
            </div>

            {/* PLANO GESTÃO AVANÇADA */}
            <div className="bg-white border border-slate-200 rounded-[3rem] p-8 shadow-xl flex flex-col transition-transform hover:scale-[1.02]">
              <div className="mb-8 text-center">
                <h3 className="text-lg font-black text-purple-600 uppercase tracking-widest">Gestão Avançada</h3>
                <p className="text-slate-500 font-bold text-xs mt-2 leading-relaxed min-h-[32px]">Gestão completa do seu delivery</p>
                <div className="flex items-baseline justify-center gap-1 my-8">
                  <span className="text-xl font-bold text-slate-900">R$</span>
                  <span className="text-5xl font-black text-slate-900 tracking-tighter">119,90</span>
                  <span className="text-slate-400 font-bold text-sm">/mês</span>
                </div>
              </div>

              <ul className="space-y-3.5 mb-10 flex-1">
                <li className="flex items-center gap-3 text-purple-600 font-black text-[10px] uppercase tracking-widest mb-4">
                  Tudo do Profissional, mais:
                </li>
                {[
                  "Relatórios avançados",
                  "Comparativos mensais",
                  "Ticket médio e horários de pico",
                  "Produtos mais vendidos",
                  "Visão estratégica do negócio",
                  "Suporte premium"
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-slate-700 font-semibold text-xs">
                    <div className="w-4 h-4 bg-purple-50 text-purple-600 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M5 13l4 4L19 7"></path></svg>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>

              <div className="pt-6 border-t border-slate-50">
                <p className="text-[10px] font-black text-purple-600 uppercase tracking-widest text-center mb-5">Para quem quer crescer com dados.</p>
                <button 
                  onClick={() => handleHireClick('Gestão Avançada')}
                  className="block w-full bg-slate-900 text-white text-center font-black py-4 rounded-2xl hover:bg-black transition-all text-sm"
                >
                  Contratar Agora
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-100 py-16 px-6 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto flex flex-col items-center gap-4 text-center">
          <p className="text-slate-400 font-medium text-sm">&copy; 2024 Delyon. Licenciado para parceiros.</p>
          <span className="text-[10px] font-bold text-slate-600 uppercase tracking-widest">
            Criado por{' '}
            <a 
              href="https://www.flowdevstudio.com.br" 
              target="_blank" 
              className="hover:text-orange-600 transition-colors"
            >
              Flow Dev Studio
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
};
